<form>
  <div mat-dialog-content class="air-theme">

    <div fxLayout="row" class="flexwrap">

      <div fxFlex>

        <div fxFlex="100%">
          <mat-form-field class="campoFormulario">
            <mat-label>{{ 'protocolEdit.dialog.equipment.type.label' | translate }}</mat-label>
            <mat-select required name="idType" [(ngModel)]="data.essay.idEssayType"
              (selectionChange)="onTypeChange($event)" [disabled]="data.isEdit">
              <mat-select-filter [displayMember]="'translated'" [array]="essays"
                (filteredReturn)="essaysFiltered =$event"
                [noResultsMessage]="'common.noResults' | translate"
              [placeholder]="'common.selectFilterPlaceholder' | translate"> </mat-select-filter>
              @for (item of essaysFiltered; track item) {
                <mat-option [value]="item.id">
                  {{ item.translated }}
                </mat-option>
              }
            </mat-select>
            <mat-error>
              {{ 'protocolEdit.dialog.equipment.type.error' | translate }}
            </mat-error>
          </mat-form-field>
        </div>

        @if (units?.length !== 0) {
          <div fxFlex="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'calibrateEquipmentEdit.calibrationData.unit.label' | translate }}</mat-label>
              <mat-select name="unit" [(ngModel)]="data.essay.idUnit" required [disabled]="units.length < 2">
                @for (item of units; track item) {
                  <mat-option [value]="item.id">
                    {{item.unit}}
                  </mat-option>
                }
              </mat-select>
              <mat-error>
                {{ 'calibrateEquipmentEdit.calibrationData.unit.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        }

      </div>

      @if (data.essay.idEssayType != null) {
        <mat-toolbar color="secondary">
          {{ 'protocolEdit.dialog.essay.fieldsTitle' | translate }}
        </mat-toolbar>
      }

      @if (data.essay.idEssayType != null) {
        <div fxFlex>
          <div fxLayout="row" class="flexwrap">
            @for (field of data.essay.essayValues; track field; let indexField = $index) {
              <div fxFlex="50" fxFlex.lt-md="100%"
                >
                <!-- STRING -->
                @if (field.idTypeField == 1) {
                  <div>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}</mat-label>
                      <input matInput
                        [name]="field.translationField" [(ngModel)]="field.value"
                        [errorStateMatcher]="matcher" [disabled]="data.disabled" [required]="field.required"
                        [ngModelOptions]="{standalone: true}">
                      <mat-error>
                        {{ 'protocolEdit.dialog.essay.' + field.translationField + '.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }
                <!-- NUMÉRICO -->
                @if (field.idTypeField == 2) {
                  <div>
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}</mat-label>
                      <input matInput
                        [name]="field.translationField" [(ngModel)]="field.value"
                        [ngModelOptions]="{standalone: true}" [errorStateMatcher]="matcher"
                        (ngModelChange)="setValue(field, -1, $event)" type="number"
                        [disabled]="data.disabled" [required]="field.required">
                      <mat-error>
                        {{ 'protocolEdit.dialog.essay.' + field.translationField + '.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                }
                <!-- TOLERANCIA -->
                @if (field.idTypeField == 3) {
                  <div>
                    <div fxFlex="40%" fxFlex.lt-md="100%">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}</mat-label>
                        <input matInput
                          [name]="field.translationField" [(ngModel)]="field.value[0]"
                          [ngModelOptions]="{standalone: true}"
                          (ngModelChange)="setValue(field, 0, $event)" [errorStateMatcher]="matcher"
                          type="number" [disabled]="data.disabled" [required]="field.required">
                        <mat-error>
                          {{ 'protocolEdit.dialog.essay.' + field.translationField + '.error' | translate
                          }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div fxFlex="40%" fxFlex.lt-md="100%">
                      ±
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'protocolEdit.dialog.essay.valueTolerance.label' | translate }}</mat-label>
                        <input matInput
                          [name]="field.translationField + 'Tolerance'" [(ngModel)]="field.value[1]"
                          (ngModelChange)="setValue(field, 1, $event)" [errorStateMatcher]="matcher"
                          type="number" [disabled]="data.disabled" [required]="field.required"
                          [ngModelOptions]="{standalone: true}">
                        <mat-error>
                          {{ 'protocolEdit.dialog.essay.valueTolerance.error' | translate }}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                }
                <!-- DIA HORA MIN -->
                @if (field.idTypeField == 4) {
                  <div>
                    <div fxLayout="row">
                      <div fxFlex="34%" fxFlex.lt-md="100%">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}: {{ 'common.days.label' | translate }}</mat-label>
                          <input matInput [name]="field.translationField + 'Day'"
                            [(ngModel)]="field.value[0]" (ngModelChange)="setValue(field, 0, $event)"
                            [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                            [required]="field.required" min="0" min="0"
                            [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      </div>
                      <div fxFlex="33%" fxFlex.lt-md="100%">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'common.hours.label' | translate }}</mat-label>
                          <input matInput [name]="field.translationField + 'Hour'"
                            [(ngModel)]="field.value[1]" (ngModelChange)="setValue(field, 1, $event)"
                            [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                            [required]="field.required" min="0" min="0"
                            [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      </div>
                      <div fxFlex="33%" fxFlex.lt-md="100%">
                        <mat-form-field class="campoFormulario">
                          <mat-label>{{ 'common.minutes.label' | translate }}</mat-label>
                          <input matInput [name]="field.translationField + 'Minute'"
                            [(ngModel)]="field.value[2]" (ngModelChange)="setValue(field, 2, $event)"
                            [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                            [required]="field.required" min="0" [ngModelOptions]="{standalone: true}">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                }
                <!-- SELECT_ONE -->
                @if (field.idTypeField == 6) {
                  <div>
                    <span>
                      {{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}
                    </span>
                    <br />
                    <mat-radio-group class="vertical-radio-group" [required]="field.required">
                      @for (doma of field.fieldDomain; track doma) {
                        <mat-radio-button class="vertical-radio-button"
                          [value]="doma.value" (change)="setValue(field, -1, $event)"
                          [checked]="field.value == doma.value">
                          {{ 'protocolEdit.dialog.essay.' + doma.translation + '.label' | translate }}
                        </mat-radio-button>
                      }
                    </mat-radio-group>
                  </div>
                }
                <!-- SELECT_MULTI -->
                @if (field.idTypeField == 7) {
                  <div>
                    <span>
                      {{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}
                      @if (field.required) {
                        <span>*</span>
                      }
                    </span>
                    <mat-selection-list [disabled]="data.disabled"
                      (selectionChange)="setValue(field, -1, $event)">
                      @for (doma of field.fieldDomain; track doma) {
                        <mat-list-option checkboxPosition="before"
                          [disabled]="data.disabled" [value]="doma.value"
                          [selected]="isSelectedMulti(field.value, doma.value)">
                          {{ 'protocolEdit.dialog.essay.' + doma.translation + '.label' | translate }}
                        </mat-list-option>
                      }
                    </mat-selection-list>
                  </div>
                }
                <!-- BOOLEAN -->
                @if (field.idTypeField == 8) {
                  <div>
                    <mat-checkbox [value]="field.value" [checked]="field.value == 'true'"
                      [disabled]="data.disabled" (change)="setValue(field, -1, $event)">
                      {{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}
                    </mat-checkbox>
                  </div>
                }
              </div>
            }
            @if (data.essay?.essayValues?.length == 0) {
              <div fxFlex="50" fxFlex.lt-md="100%"
                style="margin-top: 2em;margin-bottom: 2em;">
                {{ 'protocolEdit.dialog.essay.fields.empty' | translate }}
              </div>
            }
          </div>
        </div>
      }

      @if (data.essay.idEssayType != null) {
        <mat-toolbar color="secondary">
          {{ 'protocolEdit.dialog.essay.criteriaTitle' | translate }}
          @if (showNewCriteria()) {
            <button mat-icon-button color="accent" (click)="openNewCriteria()">
              <mat-icon>add</mat-icon>
            </button>
          }
        </mat-toolbar>
      }

      @if (data.essay.idEssayType != null && showNewCriteria()) {
        <div fxLayout="row" class="flexwrap" style="width: 100%;"
          >
          <div fxFlex>
            <table mat-table matSort #criteriaTable [dataSource]="data.essay.criterias">
              <!-- criteria Column -->
              <ng-container matColumnDef="criteria">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'protocolEdit.dialog.essay.criteria.cols.criteria' | translate }}
                </th>
                <td mat-cell *matCellDef="let item"> {{ showCriteria(item) }} </td>
              </ng-container>
              <!-- Button edit Column -->
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                <td mat-cell *matCellDef="let element; let criteriaIndex = index">
                  <button mat-icon-button (click)="editCriteria(criteriaIndex)">
                    <mat-icon>mode_edit</mat-icon>
                  </button>
                </td>
              </ng-container>
              <!-- Button delete Column -->
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
                <td mat-cell *matCellDef="let element; let criteriaIndex = index">
                  <button mat-icon-button (click)="removeCriteria(criteriaIndex)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColsCriteria"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColsCriteria;"></tr>
            </table>
          </div>
        </div>
      }
      @if (data.essay.idEssayType != null && !showNewCriteria()) {
        <div fxFlex
          style="margin-top: 2em;margin-bottom: 2em;">
          {{ 'protocolEdit.dialog.essay.fields.empty' | translate}}
        </div>
      }
    </div>
    <div fxLayout="row" class="flexwrap">
      <mat-toolbar color="secondary">
        {{ 'protocolEdit.observations.title' | translate }}
      </mat-toolbar>

      <div fxLayout="row" style="width: 100%;">
        <div fxFlex>
          <mat-form-field class="campoFormulario" style="width: 100%">
            <mat-label>{{ 'protocolEdit.observations.label' | translate }}</mat-label>
            <textarea rows="5" matAutosizeMinRows="5" matInput
              [(ngModel)]="data.essay.notes" name="observations" style="resize: none;">
            </textarea>
          </mat-form-field>
        </div>
      </div>
    </div>

    @if (!data.isExecution && data.essay.idEssayType != null && (data.essay.purpose || data.essay.methodology)) {
      <div fxLayout="row" class="flexwrap">
          <mat-toolbar color="secondary">
              {{ 'protocolEdit.essay.dialog.reportConfig.title' | translate }}
          </mat-toolbar>

          <div fxFlex="100" fxLayout="column">

              <div fxFlex="100">
                  <mat-accordion>
                      <mat-expansion-panel class="overflowX essay-dialog-mat-accordion" [expanded]="purposeTab" (opened)="purposeTab = true" (closed)="purposeTab = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div fxFlex="100">
                                    <div fxFlex="100">
                                      <div fxFlex="90" class="center-text">
                                            <span [class]="purposeTab ? 'bold' : ''">{{'protocolEdit.essay.dialog.reportConfig.purpose.title' | translate}}</span>
                                      </div>
                                        <div fxFlex="10">
                                            <button mat-icon-button (click)="refreshPurpose()"
                                                matTooltip="{{ 'button.refresh' | translate }}">
                                                <mat-icon>refresh</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div fxFlex="100" fxLayout="column">
                          <div fxFlex="100">
                              @if (data.essay.purposeTranslated) {
                                <span>{{'protocolEdit.dialog.essay.language.original' | translate}}</span>
                                <br />
                              }
                              <quill-editor class="quill-container ql-editor" [(ngModel)]="data.essay.purpose" [name]="'purpose'" [id]="'purpose'" [modules]="quillConfig" style="height: auto; font-weight: normal;"></quill-editor>
                          </div>

                          @if (data.essay.purposeTranslated) {
                            <div fxFlex="100">
                                <span>{{'protocolEdit.dialog.essay.language.translate' | translate}}</span>
                                <br />
                                <quill-editor class="quill-container ql-editor" [(ngModel)]="data.essay.purposeTranslated" [name]="'purposeTranslated'" [id]="'purposeTranslated'" [modules]="quillConfig" style="height: auto; font-weight: normal;"></quill-editor>
                            </div>
                          }
                        </div>
                      </mat-expansion-panel>
                  </mat-accordion>
              </div>

              <div fxFlex="100">
                  <mat-accordion>
                      <mat-expansion-panel class="overflowX essay-dialog-mat-accordion" [expanded]="methologyTab" (opened)="methologyTab = true" (closed)="methologyTab = false">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div fxFlex="100">
                                    <div fxFlex="100">
                                        <div fxFlex="90" class="center-text">
                                            <span [class]="methologyTab ? 'bold' : ''">{{'protocolEdit.essay.dialog.reportConfig.methodology.title' | translate}}</span>
                                        </div>
                                        <div fxFlex="10">
                                            <button mat-icon-button (click)="refreshMethodology()"
                                                matTooltip="{{ 'button.refresh' | translate }}">
                                                <mat-icon>refresh</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div fxFlex="100" fxLayout="column">
                          <div fxFlex="100">
                              @if (data.essay.methodologyTranslated) {
                                <span>{{'protocolEdit.dialog.essay.language.original' | translate}}</span>
                                <br />
                              }
                              <quill-editor class="quill-container ql-editor" [(ngModel)]="data.essay.methodology" [name]="'methodology'" [id]="'methodology'" [modules]="quillConfig" style="height: auto; font-weight: normal;"></quill-editor>
                          </div>
                          @if (data.essay.methodologyTranslated) {
                            <div fxFlex="100">
                                <span>{{'protocolEdit.dialog.essay.language.translate' | translate}}</span>
                                <br />
                                <quill-editor class="quill-container ql-editor" [(ngModel)]="data.essay.methodologyTranslated" [name]="'methodologyTranslated'" [id]="'methodologyTranslated'" [modules]="quillConfig" style="height: auto; font-weight: normal;"></quill-editor>
                            </div>
                          }
                        </div>
                      </mat-expansion-panel>
                  </mat-accordion>
              </div>
          </div>
      </div>
    }
  </div>
  <div mat-dialog-actions class="air-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial
    [disabled]="data.essay.idEssayType == null">{{ 'button.save' | translate }}</button>
    @if (data.isEdit) {
      <button mat-raised-button color="accent" (click)="delete()">
      {{ 'button.delete' | translate }}</button>
    }
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>